import React from 'react'

export interface ITableConfiguration {
  title: string | React.ReactNode
  dataIndex: string
  editable: boolean | false
  width?: number | 100
  isRequired?: boolean | false
  isNumber?: boolean | false
  isAmount?: boolean | false
  isAction?: boolean | false
  textColor?: string
  textWeight?: string
}

export interface StandardResult<T = any> {
  success?: boolean | false
  message?: string
  data?: T
}

export interface ApiResponse<T = any> {
  message?: string | null
  data?: T
}
export interface ApiResponseError {
  error?: string | null
}

export interface ErrorResponse {
  message?: string | null
}

export interface SelectOption {
  value: number
  label: string
}

export interface ApiResponseArrayError {
  error?: string[]
}

export function IsApiResponseError(err: any): err is ApiResponseError {
  return err && typeof err.error === 'string'
}

export function IsApiResponseArrayError(err: any): err is ApiResponseArrayError {
  console.log(typeof err.error, 'typeof err.error')
  return false
  // return err && typeof err.error === 'string'
}

// Helper function untuk mengecek apakah error adalah ErrorResponse
export function IsErrorResponse(err: any): err is ErrorResponse {
  return err && typeof err.message === 'string'
}
